<!-- Header Element Container -->
<div class="page-header-element" 
     *ngIf="visible"
     [class.selected]="selected"
     (click)="onHeaderClick($event)">
  
  <div class="header-wrapper">
    <div class="header-nav-container"
         [style.background-color]="backgroundColor || null">
      
      <!-- Logo Section -->
      <div class="logo-section">
        <img *ngIf="logo?.image" 
             [src]="logo?.image" 
             [alt]="logo?.alt || 'Logo'" 
             class="logo-image">
        <span *ngIf="!logo?.image && logo?.text" 
              class="logo-placeholder"
              [style.color]="getHeadingColor()"
              [style.font-family]="getHeadingFont()">{{ logo?.text }}</span>
        <span *ngIf="!logo?.image && !logo?.text" 
              class="logo-placeholder"
              [style.color]="getHeadingColor()"
              [style.font-family]="getHeadingFont()">Logo</span>
      </div>
      
      <!-- Desktop/Tablet Navigation (Hidden on Mobile) -->
      <nav class="navigation">
        <div class="nav-links-panel">
          <a *ngFor="let navItem of navigation; let i = index; trackBy: trackByIndex" 
             href="#" 
             class="nav-link"
             [class.active]="isNavigationItemActive(navItem, i)"
             [style.color]="getHeadingColor()"
             [style.font-family]="getHeadingFont()"
             (click)="onNavigationItemClick(navItem, $event)">
            {{ navItem.label }}
          </a>
        </div>
      </nav>
      
      <!-- Desktop/Tablet CTA Button -->
      <button *ngIf="ctaButton"
              class="book-wash-btn"
              [style.background-color]="ctaButton.backgroundColor || null"
              [style.color]="ctaButton.textColor || null"
              (click)="onCTAButtonClick($event)">
        {{ ctaButton.text }}
      </button>

      <!-- Mobile Hamburger Menu Button (Visible on Mobile/Tablet, Hidden when menu is open) -->
      <button *ngIf="!isMobileMenuOpen"
              class="hamburger-menu" 
              (click)="toggleMobileMenu($event)"
              aria-label="Toggle menu">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>
      
    </div>
  </div>
</div>

<!-- Mobile Menu Overlay (backdrop) -->
<div *ngIf="isMobileMenuOpen"
     class="mobile-menu-overlay" 
     [class.open]="isMobileMenuOpen"
     (click)="closeMobileMenu()">
</div>

<!-- Mobile Menu Drawer -->
<div *ngIf="isMobileMenuOpen"
     class="mobile-menu-drawer" 
     [class.open]="isMobileMenuOpen">
  
  <!-- Mobile Menu Header -->
  <div class="mobile-menu-header">
    <div class="logo-section">
      <img *ngIf="logo?.image" 
           [src]="logo?.image" 
           [alt]="logo?.alt || 'Logo'" 
           class="logo-image">
      <span *ngIf="!logo?.image && logo?.text" 
            class="logo-placeholder"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()">{{ logo?.text }}</span>
      <span *ngIf="!logo?.image && !logo?.text" 
            class="logo-placeholder"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()">Logo</span>
    </div>
    <button class="close-menu-btn" 
            (click)="closeMobileMenu()"
            aria-label="Close menu">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
  
  <!-- Mobile Navigation Menu -->
  <nav class="mobile-navigation">
    <a *ngFor="let navItem of navigation; let i = index; trackBy: trackByIndex" 
       href="#"
       class="mobile-nav-link"
       [class.active]="isNavigationItemActive(navItem, i)"
       [style.color]="getHeadingColor()"
       [style.font-family]="getHeadingFont()"
       (click)="onNavigationItemClick(navItem, $event)">
      {{ navItem.label }}
    </a>
  </nav>
  
  <!-- Mobile CTA Button -->
  <div class="mobile-cta-section">
    <button *ngIf="ctaButton"
            class="mobile-book-wash-btn"
            [style.background-color]="ctaButton.backgroundColor || null"
            [style.color]="ctaButton.textColor || null"
            (click)="onCTAButtonClick($event)">
      {{ ctaButton.text }}
    </button>
  </div>
  
</div>
